import { render, staticRenderFns } from "./distinct_open_association.vue?vue&type=template&id=ef04d524&scoped=true&"
import script from "./distinct_open_association.vue?vue&type=script&lang=js&"
export * from "./distinct_open_association.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef04d524",
  null
  
)

export default component.exports